import jquery from 'jquery';

declare global {
    interface Window {
        jQuery: JQueryStatic;
        $: JQueryStatic;
    }
}

if (!window.jQuery) {
    window.jQuery = jquery;
    window.$ = jquery;
}

export {jquery as $};